import { z } from 'zod';

import { VoiceCallBlockConfigSchema } from './config.js';
import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export { VoiceCallBlockConfigSchema };

export const VoiceCallV2BlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.VoiceCallV2),
  config: VoiceCallBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.VoiceCallV2),
});
export type VoiceCallV2Block = z.infer<typeof VoiceCallV2BlockSchema>;
